<template>
	<view class="pb10 theme-bg">
		<view class="status_bar"></view>
		<view class="top_view"></view>
	</view>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
	}
</script>

<style>
</style>
